module.exports = __webpack_public_path__ + "media/images/logo-enquirer-e0f5e8df803a116eb50503dc7ca6ab1e.png";